(function () {
  if (window.__alSlots || !('IntersectionObserver' in window)) return;
  window.__alSlots = 1;
  function ga(name, params) { if (typeof window.gtag === 'function') window.gtag('event', name, params); }
  function info(el) { return { section: el.dataset.slot, section_position: +el.dataset.slotPos || 0 }; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      if (e.intersectionRect.height < Math.min(e.boundingClientRect.height, window.innerHeight) * 0.5) return;
      io.unobserve(e.target);
      ga('section_view', info(e.target));
    });
  }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
  function init() {
    var els = document.querySelectorAll('[data-slot]');
    for (var i = 0; i < els.length; i++) { els[i].dataset.slotPos = i + 1; io.observe(els[i]); }
  }
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href],button');
    var s = a && a.closest('[data-slot]');
    if (!s) return;
    var p = info(s);
    if (a.pathname) p.link_path = a.pathname;
    ga('section_click', p);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
